import { CommonModule } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { ColDef, ICellRendererParams } from 'ag-grid-community';

// EZ
import { ButtonsCellRenderer, EzButtonCellParams } from '@template-ui/components/ez-grid/cell-renderers/buttons-cell-renderer/buttons-cell-renderer.component';
import { EzBaseComponent } from '@template-ui/components/ez-base.component';
import { DocMeta } from '@template-ui/decorators';
import { UiLibraryModule } from '@template-ui/template-ui.module';
import { ButtonConfig, PanelHeaderConfig } from '@template-ui/types';

type StarWarsActor = {
  id: string;
  firstName: string;
  lastName: string;
  notableRole: string;
  trilogy: string;
  isLiving: boolean;
  actions?: unknown;
};

@DocMeta({
  hide: true,
  category: 'Components',
  showcaseTitle: 'Cell Renderers',
  showcaseDesc: `Demonstrates cell renderer patterns using \`ButtonsCellRenderer\` with a \`hidden\` signal resolved per row context.`,
  showcaseAttachTo: [{ libName: 'Base Library', classNames: ['EzGridComponent'] }],
})
@Component({
  selector: 'ui-grid-button-renderer-sample, ez-grid-button-renderer-sample',
  standalone: true,
  imports: [CommonModule, UiLibraryModule],
  templateUrl: './ez-grid-button-renderer-sample.component.html',
  styleUrl: './ez-grid-button-renderer-sample.component.scss',
})
export class EzGridButtonRendererSampleComponent extends EzBaseComponent {
  protected readonly panelHeaderConfig: PanelHeaderConfig = {
    panelHeaderTitle: 'Star Wars Actors',
    subtitle: 'ButtonsCellRenderer | hidden uses a per-row signal',
    showReloadButton: true,
  };

  protected readonly colDefs: ColDef<StarWarsActor>[] = [
    { field: 'id', headerName: 'Id', maxWidth: 120 },
    { field: 'firstName', headerName: 'First Name' },
    { field: 'lastName', headerName: 'Last Name' },
    { field: 'notableRole', headerName: 'Notable Role', minWidth: 220 },
    { field: 'trilogy', headerName: 'Trilogy', maxWidth: 140 },
    { field: 'isLiving', headerName: 'Is Living', maxWidth: 120 },
    {
      field: 'actions',
      headerName: 'Actions',
      maxWidth: 160,
      cellRenderer: ButtonsCellRenderer,

      // AG-Grid can accept a function with a params argument for cellRenderParams but its not documented
      // very well.
      cellRendererParams: ((params: ICellRendererParams<StarWarsActor>) => {
        const viewButton: ButtonConfig = {
          id: 'view',
          buttonText: 'View',
          hidden: computed(() => !params.data?.isLiving),
        };

        return { buttonsConfig: [viewButton] }
      }) satisfies (params: ICellRendererParams<StarWarsActor>) => EzButtonCellParams,
    },
  ];

  constructor() {
    super();
    this.thisClassName = 'EzGridButtonRendererSampleComponent';
  }
}
